import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { LoginConfigView } from "../login-config.view";

@Component({
    selector: "login-config-section",
    templateUrl: "./login-config-section.view.html",
    providers: []
})
export class LoginConfigSectionView extends LoginConfigView {
}
